module.exports = __webpack_public_path__ + "slide-1-uFb.jpg";